import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Root = styled.span`
  display: inline-block;
  position: relative;
  margin-right: ${props => props.mr || 0}px;
  margin-left: ${props => props.ml || 0}px;
  vertical-align: middle;
  line-height: 100%;

  top: ${props => props.top || 0}px;
  right: ${props => props.right || 0}px;
  bottom: ${props => props.bottom || 0}px;
  left: ${props => props.left || 0}px;
`;

const rederIcon = (name, color) => {
  switch (name) {
    case 'keynote':
      return (
        <svg
          width="11"
          height="12"
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 7.5V11.5M4 4L7 4M1 0.5H10V7.5H1V0.5Z"
            stroke={color || '#FD6F48'}
          />
        </svg>
      );
    case 'plus':
      return (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 7.00001L6.50002 7.00001M6.50002 7.00001L13 7.00001M6.50002 7.00001L6.50002 0.5M6.50002 7.00001V13.5"
            stroke={color || '#FD6F48'}
          />
        </svg>
      );
    case 'minus':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.5 7L7.00002 7L13.5 7" stroke={color || '#FD6F48'} />
        </svg>
      );
    case 'minus5':
      return (
        <svg
          width="18"
          height="11"
          viewBox="0 0 18 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.469219 7.06738V5.77051H3.83195V7.06738H0.469219ZM8.13964 4.04353C8.75223 4.04353 9.29097 4.15432 9.75584 4.37589C10.2251 4.59312 10.59 4.91462 10.8507 5.3404C11.1114 5.76182 11.2417 6.27883 11.2417 6.89143C11.2417 7.5605 11.1005 8.13833 10.8181 8.62493C10.5357 9.10718 10.1208 9.47865 9.57337 9.73932C9.02594 10 8.35905 10.1303 7.57267 10.1303C7.07304 10.1303 6.60599 10.0869 6.17153 10C5.74141 9.91311 5.36995 9.78277 5.05714 9.60898V8.2274C5.38298 8.40987 5.774 8.55976 6.23018 8.67706C6.68637 8.79002 7.123 8.8465 7.54009 8.8465C7.98324 8.8465 8.36339 8.78133 8.68055 8.651C8.9977 8.52066 9.241 8.32081 9.41044 8.05144C9.58423 7.78207 9.67112 7.44102 9.67112 7.02828C9.67112 6.48086 9.49516 6.05943 9.14325 5.764C8.79568 5.46422 8.25043 5.31433 7.5075 5.31433C7.24682 5.31433 6.96877 5.33822 6.67333 5.38602C6.38224 5.42946 6.13895 5.47725 5.94344 5.52939L5.27219 5.13186L5.63063 0.472252H10.5835V1.82126H6.97963L6.77109 4.19342C6.92749 4.15866 7.11431 4.12608 7.33154 4.09566C7.54877 4.06091 7.81814 4.04353 8.13964 4.04353ZM17.8824 7.94065C17.8824 8.41421 17.7673 8.81392 17.5371 9.13977C17.3068 9.46561 16.9701 9.71326 16.5269 9.8827C16.0881 10.0478 15.5494 10.1303 14.9107 10.1303C14.4068 10.1303 13.9723 10.0934 13.6073 10.0196C13.2467 9.95004 12.9057 9.84142 12.5842 9.6937V8.37077C12.9274 8.53152 13.3119 8.67055 13.7377 8.78785C14.1678 8.90516 14.574 8.96381 14.9563 8.96381C15.4603 8.96381 15.8231 8.88561 16.0447 8.7292C16.2663 8.56845 16.377 8.35556 16.377 8.09054C16.377 7.93413 16.3314 7.79511 16.2402 7.67346C16.1533 7.54746 15.9882 7.4193 15.7449 7.28896C15.5059 7.15428 15.154 6.99352 14.6892 6.80671C14.233 6.62423 13.8485 6.44176 13.5357 6.25928C13.2228 6.07681 12.9861 5.85741 12.8253 5.60107C12.6646 5.3404 12.5842 5.00803 12.5842 4.60398C12.5842 3.96533 12.8362 3.4809 13.3402 3.15071C13.8485 2.81617 14.5197 2.64891 15.3539 2.64891C15.797 2.64891 16.2141 2.69452 16.6051 2.78576C17.0005 2.87265 17.3872 3.00082 17.7651 3.17026L17.2829 4.32376C16.957 4.18038 16.629 4.06308 16.2988 3.97184C15.973 3.87626 15.6406 3.82847 15.3017 3.82847C14.9064 3.82847 14.6044 3.88929 14.3959 4.01094C14.1917 4.13259 14.0896 4.30638 14.0896 4.5323C14.0896 4.70174 14.1396 4.84511 14.2395 4.96242C14.3394 5.07972 14.511 5.19702 14.7543 5.31433C15.002 5.43163 15.3452 5.57718 15.784 5.75096C16.2141 5.91606 16.5856 6.08984 16.8984 6.27232C17.2155 6.45045 17.4588 6.66985 17.6283 6.93053C17.7977 7.1912 17.8824 7.52791 17.8824 7.94065Z"
            fill="#808B91"
          />
        </svg>
      );
    case 'restart':
      return (
        <svg
          width="13"
          height="12"
          viewBox="0 0 13 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 0.5H3.5V11.5H0.5V0.5ZM12.5 11L5.83333 6L12.5 1L12.5 11Z"
            stroke={color || '#808B91'}
          />
        </svg>
      );
    case 'play':
      return (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15 8L0 16L7.57103e-07 0L15 8Z" fill="white" />
        </svg>
      );
    case 'pause':
      return (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 0H6.2V16H1V0Z" fill="white" />
          <path d="M8.8 0H14V16H8.8V0Z" fill="white" />
        </svg>
      );
    case 'arrowLeft':
      return (
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.36396 13.7279L1 7.36396M1 7.36396L7.36396 1M1 7.36396L13.7279 7.36396"
            stroke={color || '#808B91'}
          />
        </svg>
      );
    case 'arrowRight':
      return (
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.36396 1L12.7279 7.36396M12.7279 7.36396L6.36396 13.7279M12.7279 7.36396H0"
            stroke={color || '#808B91'}
          />
        </svg>
      );
    case 'search':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.9111 14L8.01111 9.1C7.62222 9.41111 7.175 9.65741 6.66944 9.83889C6.16389 10.0204 5.62593 10.1111 5.05556 10.1111C3.64259 10.1111 2.44689 9.62189 1.46844 8.64344C0.489482 7.66448 0 6.46852 0 5.05556C0 3.64259 0.489482 2.44663 1.46844 1.46767C2.44689 0.489222 3.64259 0 5.05556 0C6.46852 0 7.66448 0.489222 8.64344 1.46767C9.62189 2.44663 10.1111 3.64259 10.1111 5.05556C10.1111 5.62593 10.0204 6.16389 9.83889 6.66944C9.65741 7.175 9.41111 7.62222 9.1 8.01111L14 12.9111L12.9111 14ZM5.05556 8.55556C6.02778 8.55556 6.8543 8.21541 7.53511 7.53511C8.21541 6.8543 8.55556 6.02778 8.55556 5.05556C8.55556 4.08333 8.21541 3.25681 7.53511 2.576C6.8543 1.8957 6.02778 1.55556 5.05556 1.55556C4.08333 1.55556 3.25681 1.8957 2.576 2.576C1.8957 3.25681 1.55556 4.08333 1.55556 5.05556C1.55556 6.02778 1.8957 6.8543 2.576 7.53511C3.25681 8.21541 4.08333 8.55556 5.05556 8.55556Z"
            fill={color || '#FFFFFF'}
          />
        </svg>
      );
    case 'arrowTopRight':
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L10 0.999999M10 0.999999L10 10M10 0.999999L1 10"
            stroke={color || '#FD6F48'}
          />
        </svg>
      );
    case 'arrowExternalLink':
      return (
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="9.16675"
            cy="9.5"
            r="8.15377"
            stroke={color || '#808B91'}
            strokeWidth="1.35896"
          />
          <path
            d="M6 7L12 7M12 7L12 13M12 7L6 13"
            stroke={color || '#808B91'}
          />
        </svg>
      );
    case 'phone':
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3 12C9.86667 12 8.46956 11.6804 7.10867 11.0413C5.74733 10.4027 4.54178 9.55822 3.492 8.508C2.44178 7.45822 1.59733 6.25267 0.958667 4.89133C0.319556 3.53044 0 2.13333 0 0.7C0 0.5 0.0666666 0.333333 0.2 0.2C0.333333 0.0666666 0.5 0 0.7 0H3.4C3.55556 0 3.69444 0.0499999 3.81667 0.15C3.93889 0.25 4.01111 0.377778 4.03333 0.533333L4.46667 2.86667C4.48889 3.02222 4.48622 3.16378 4.45867 3.29133C4.43067 3.41933 4.36667 3.53333 4.26667 3.63333L2.66667 5.26667C3.13333 6.06667 3.71667 6.81667 4.41667 7.51667C5.11667 8.21667 5.88889 8.82222 6.73333 9.33333L8.3 7.76667C8.4 7.66667 8.53067 7.59156 8.692 7.54133C8.85289 7.49156 9.01111 7.47778 9.16667 7.5L11.4667 7.96667C11.6222 8 11.75 8.07489 11.85 8.19133C11.95 8.30822 12 8.44444 12 8.6V11.3C12 11.5 11.9333 11.6667 11.8 11.8C11.6667 11.9333 11.5 12 11.3 12Z"
            fill="white"
          />
        </svg>
      );
    case 'filter':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.916992 13.418V12.501H5.24999V13.418H0.916992ZM0.916992 3.50097V2.58397H8.35399V3.50097H0.916992ZM7.62499 15.084V10.855H8.54199V12.501H15.083V13.418H8.54199V15.084H7.62499ZM4.33299 10.126V8.45897H0.916992V7.54297H4.33299V5.89697H5.24999V10.126H4.33299ZM7.62499 8.45897V7.54297H15.083V8.45897H7.62499ZM10.75 5.14697V0.917969H11.667V2.58397H15.083V3.50097H11.667V5.14697H10.75Z"
            fill={color || '#FD6F48'}
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.28247 14.7183L14.7175 1.28323M1.28249 1.2832L14.7175 14.7182"
            stroke={color || '#FD6F48'}
          />
        </svg>
      );
    case 'arrowBottomRight':
      return (
        <svg
          width="11"
          height="10"
          viewBox="0 0 11 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 0.5V9.5M10 9.5H1M10 9.5L1 0.5"
            stroke={color || '#FD6F48'}
          />
        </svg>
      );
    case 'chevron':
      return (
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L5 5L9 1" stroke={color || '#FD6F48'} />
        </svg>
      );
    default:
      return null;
  }
};

const IconSVG = ({
  name,
  color,
  mr,
  ml,
  top,
  left,
  right,
  bottom,
  className
}) => {
  if (name) {
    return (
      <Root
        mr={mr}
        ml={ml}
        top={top}
        left={left}
        right={right}
        bottom={bottom}
        className={className}
      >
        {rederIcon(name, color)}
      </Root>
    );
  }

  return null;
};

IconSVG.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  mr: PropTypes.number,
  ml: PropTypes.number,
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number
};

export default IconSVG;
